import { useIntl } from "react-intl";

import { ExpandableSection } from "@/components/ExpandableSection/ExpandableSection";

export function AdditionalInfoCard() {
  const intl = useIntl();

  return (
    <>
      <div className="section-title mt-4">
        {intl.formatMessage({ id: "flights.additionalInfo" })}
      </div>
      <div className="section-card mt-2">
        <ExpandableSection>
          <div className="flex w-full flex-col gap-2">
            <h3 className="text-sm font-medium text-text-primary">
              {intl.formatMessage({
                id: "flights.baggage.regulationsOnSpecialBaggage",
              })}
            </h3>
            <p className="text-sm font-normal text-text-primary">
              {intl.formatMessage({ id: "flights.regulationsDetails" })}
            </p>
          </div>
        </ExpandableSection>
      </div>
    </>
  );
}
